export default __webpack_public_path__ + "static/media/Spend-min.1df1fca5.png";